module.exports = __webpack_public_path__ + "static/video_bg-1aaf50b99896a5952606ca0cdb6faf06.jpg";